var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _a, _b, _c, _d, _e, _f, _g, _h;
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-fallthrough */
import * as actions from 'app/actions/map';
import * as notificationActions from 'app/actions/notification';
import http from 'app/services/http';
import { MAP_SET_TRANSPORT_HISTORY_ITEMS_CONDITIONS, SET_HISTORY_SELECTED_TIME, SET_HISTORY_TRACKS_VISIBLE, SET_IS_HISTORY_OPEN, SET_TRANSPORT_HISTORY_TRACKS_ITEMS, SET_TRANSPORT_SELECTED_DATE } from 'app/utils/constants';
import { resolveNextMotionGalileoskyDate } from 'app/utils/motionGalileoskyDate';
import moment from 'moment/moment';
// worker-loader: classic worker script without ES module exports
// @ts-expect-error worker module is provided by worker-loader at build time
import HistoryStreamWorker from '../workers/historyStream.worker.ts';
// Динамический импорт WebWorker через worker-loader
const getHistoryStreamWorker = () => new HistoryStreamWorker();
// Кеш WebWorker для повторного использования
let historyStreamWorker = null;
const initialState = {
    ref: null,
    zoom: 14,
    bounds: null,
    layerSelected: config.mapLayerDefault,
    geofenceMode: '',
    activeWindow: 'transport',
    transportWindowMinimize: false,
    transportTab: 'condition',
    filterTab: 'transport',
    transportItems: [],
    transportSelectedItem: null,
    transportSelectedDate: [
        moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
        moment()
            .endOf('day')
            .add({
            hours: 8,
            seconds: 1,
            minutes: 1,
        })
            .format('YYYY-MM-DD HH:mm:ss'),
    ],
    transportConditionItems: [],
    transportFilterCheckedType: (_a = JSON.parse(localStorage.getItem('transportFilterCheckedType'))) !== null && _a !== void 0 ? _a : 'all',
    transportCheckedItems: (_b = JSON.parse(localStorage.getItem('transportCheckedItems'))) !== null && _b !== void 0 ? _b : [],
    transportMarkedCheckedItems: (_c = JSON.parse(localStorage.getItem('transportMarkedCheckedItems'))) !== null && _c !== void 0 ? _c : [],
    transportProcessingCheckedItems: (_d = JSON.parse(localStorage.getItem('transportProcessingCheckedItems'))) !== null && _d !== void 0 ? _d : [],
    transportSortSelectedItem: (_e = JSON.parse(localStorage.getItem('transportSortSelectedItem'))) !== null && _e !== void 0 ? _e : {
        name: config.mapTransportColumns[2].name,
        order: config.mapTransportColumns[2].order,
    },
    transportFilterCheckedItems: (_f = JSON.parse(localStorage.getItem('transportFilterCheckedItems'))) !== null && _f !== void 0 ? _f : config.mapTransportFilters.filter((filter) => !filter.hidden).map((filter) => filter.name),
    transportColumnCheckedItems: (_g = JSON.parse(localStorage.getItem('transportColumnCheckedItems'))) !== null && _g !== void 0 ? _g : config.mapTransportColumns.filter((filter) => !filter.hidden).map((column) => column.name),
    transportConditionFilterCheckedType: 'all',
    transportConditionFilterCheckedItems: (_h = JSON.parse(localStorage.getItem('transportConditionFilterCheckedItems'))) !== null && _h !== void 0 ? _h : config.mapTransportConditionFilters.reduce((accumulator, currentValue) => [...accumulator, ...currentValue.filters], []),
    transportBroadcastSelectedItem: null,
    transportConditionSelectedItem: null,
    transportConditionSelectedDatetime: null,
    transportActivityQueue: [],
    transportConditionQueue: [],
    transportSearchValue: '',
    transportGeofenceView: false,
    geofenceItems: [],
    geofenceUpdatedItem: null,
    geofenceChangedItem: null,
    geofenceUpdatedMode: 'create',
    geofenceCheckedId: [],
    geofenceGroupItems: [],
    geofenceGroupItemsLimit: 60,
    geofenceSearchValue: '',
    taskItems: [],
    taskSelectedItem: null,
    taskSortSelectedItem: { name: config.mapTaskColumns[3].name, order: config.mapTaskColumns[3].order },
    taskFilterCheckedItems: config.mapTaskFilters.map((filter) => filter.name),
    taskColumnCheckedItems: config.mapTaskColumns.map((column) => column.name),
    taskSearchValue: '',
    notificationEvents: [],
    isHistoryOpen: false,
    historySelectedTime: moment(),
    historyConditionsItems: [],
    transportHistoryTracksItems: {},
    historyTracksVisible: false,
    historyTracksProgress: { processed: 0, total: 0 },
    historyTracksLoading: false,
};
export default function mapReducer(state = initialState, action) {
    // Профилирование времени выполнения редюсера
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w;
    try {
        switch (action.type) {
            case SET_TRANSPORT_HISTORY_TRACKS_ITEMS: {
                const { items } = action.payload;
                let transportHistoryTracksItems = {};
                for (let key in items) {
                    const transportData = items[key];
                    transportHistoryTracksItems[key] = {};
                    for (const intervalKey in transportData) {
                        const intervalData = transportData[intervalKey];
                        if (intervalData && intervalData.binary && intervalData.data instanceof ArrayBuffer) {
                            transportHistoryTracksItems[key][intervalKey] = intervalData;
                        }
                    }
                }
                return Object.assign(Object.assign({}, state), { transportHistoryTracksItems });
            }
            // Обработка стриминг экшенов
            case 'MAP_SET_HISTORY_TRACKS_PROGRESS': {
                const { progress, total, percent, intervalIndex, totalIntervals } = action.payload;
                return Object.assign(Object.assign({}, state), { historyTracksProgress: {
                        processed: progress,
                        total,
                        percent: percent || Math.round((progress / total) * 100),
                        intervalIndex,
                        totalIntervals,
                    } });
            }
            case 'MAP_ADD_HISTORY_TRACK_ITEM': {
                const { data, intervalKey } = action.payload;
                // Логируем входящие данные
                const transportIds = Object.keys(data || {});
                if (transportIds.length > 0) {
                    const firstId = transportIds[0];
                    const firstData = data[firstId];
                    console.log('[REDUCER] MAP_ADD_HISTORY_TRACK_ITEM:', {
                        intervalKey,
                        transportsCount: transportIds.length,
                        firstId,
                        firstDataKeys: firstData ? Object.keys(firstData) : 'none',
                        isBinary: firstData === null || firstData === void 0 ? void 0 : firstData.binary,
                        hasArrayBuffer: (firstData === null || firstData === void 0 ? void 0 : firstData.data) instanceof ArrayBuffer,
                        hasUint8Array: (firstData === null || firstData === void 0 ? void 0 : firstData.data) instanceof Uint8Array,
                        isArray: Array.isArray(firstData),
                    });
                }
                const newTransportHistoryTracksItems = Object.assign({}, state.transportHistoryTracksItems);
                let hasChanges = false;
                for (const transportId of Object.keys(data || {})) {
                    const transportData = data[transportId];
                    if (!transportData)
                        continue;
                    const transportIntervals = newTransportHistoryTracksItems[transportId] || {};
                    // Проверяем разные форматы данных
                    const isBinary = transportData.binary === true && (transportData.data instanceof ArrayBuffer || transportData.data instanceof Uint8Array);
                    if (isBinary) {
                        // Бинарный формат от worker'а
                        const arrayBuffer = transportData.data instanceof Uint8Array ? transportData.data.buffer : transportData.data;
                        newTransportHistoryTracksItems[transportId] = Object.assign(Object.assign({}, transportIntervals), { [intervalKey]: {
                                binary: true,
                                data: arrayBuffer,
                                pointsCount: transportData.pointsCount || Math.floor(arrayBuffer.byteLength / 38),
                            } });
                        hasChanges = true;
                    }
                    else if (transportData.data && Array.isArray(transportData.data)) {
                        // JSON формат (массив точек)
                        newTransportHistoryTracksItems[transportId] = Object.assign(Object.assign({}, transportIntervals), { [intervalKey]: {
                                binary: false,
                                data: transportData.data,
                                pointsCount: transportData.data.length,
                            } });
                        hasChanges = true;
                    }
                    else if (Array.isArray(transportData)) {
                        // Старый JSON формат (прямо массив точек)
                        newTransportHistoryTracksItems[transportId] = Object.assign(Object.assign({}, transportIntervals), { [intervalKey]: {
                                binary: false,
                                data: transportData,
                                pointsCount: transportData.length,
                            } });
                        hasChanges = true;
                    }
                }
                if (!hasChanges)
                    return state;
                return Object.assign(Object.assign({}, state), { transportHistoryTracksItems: newTransportHistoryTracksItems });
            }
            case 'MAP_SET_HISTORY_TRACKS_COMPLETE': {
                console.log('[REDUCER] MAP_SET_HISTORY_TRACKS_COMPLETE, current loading:', state.historyTracksLoading);
                return Object.assign(Object.assign({}, state), { historyTracksLoading: false, historyTracksProgress: Object.assign({}, state.historyTracksProgress) });
            }
            case 'MAP_CLEAR_HISTORY_TRACKS': {
                console.log('[REDUCER] MAP_CLEAR_HISTORY_TRACKS');
                return Object.assign(Object.assign({}, state), { transportHistoryTracksItems: {}, historyTracksProgress: { processed: 0, total: 0 }, historyTracksLoading: false });
            }
            case 'MAP_SET_HISTORY_TRACKS_LOADING': {
                const { loading } = action.payload;
                console.log('[REDUCER] MAP_SET_HISTORY_TRACKS_LOADING:', loading);
                return Object.assign(Object.assign({}, state), { historyTracksLoading: loading });
            }
            case SET_TRANSPORT_SELECTED_DATE: {
                const { value } = action.payload;
                return Object.assign(Object.assign({}, state), { transportSelectedDate: value });
            }
            case MAP_SET_TRANSPORT_HISTORY_ITEMS_CONDITIONS: {
                const { items } = action.payload;
                return Object.assign(Object.assign({}, state), { historyConditionsItems: items });
            }
            case SET_HISTORY_SELECTED_TIME: {
                const { value } = action.payload;
                return Object.assign(Object.assign({}, state), { historySelectedTime: value });
            }
            case SET_IS_HISTORY_OPEN: {
                const { value } = action.payload;
                return Object.assign(Object.assign(Object.assign({}, state), { isHistoryOpen: value }), (value === true && { historyTracksVisible: false }));
            }
            case SET_HISTORY_TRACKS_VISIBLE: {
                const { value } = action.payload;
                return Object.assign(Object.assign({}, state), { historyTracksVisible: value });
            }
            case 'MAP_SET_REF': {
                const { ref } = action.payload;
                const nextBounds = (_b = (_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.getBounds) === null || _b === void 0 ? void 0 : _b.call(_a);
                return Object.assign(Object.assign({}, state), { ref: ref, bounds: nextBounds || state.bounds });
            }
            case 'MAP_SET_ZOOM': {
                const { value } = action.payload;
                return Object.assign(Object.assign({}, state), { zoom: value });
            }
            case 'MAP_SET_BOUNDS': {
                const { zoom, bounds } = action.payload;
                return Object.assign(Object.assign({}, state), { zoom: zoom, bounds: bounds });
            }
            case 'MAP_SET_LAYER_SELECTED': {
                const { value } = action.payload;
                return Object.assign(Object.assign({}, state), { layerSelected: value });
            }
            case 'MAP_SET_GEOFENCE_MODE': {
                const { value } = action.payload;
                return Object.assign(Object.assign({}, state), { geofenceMode: value });
            }
            case 'MAP_SET_ACTIVE_WINDOW': {
                const { value } = action.payload;
                return Object.assign(Object.assign({}, state), { activeWindow: value });
            }
            case 'MAP_SET_TRANSPORT_WINDOW_MINIMIZE': {
                const { flag } = action.payload;
                return Object.assign(Object.assign({}, state), { transportWindowMinimize: flag });
            }
            case 'MAP_SET_TRANSPORT_GEOFENCE_VIEW': {
                const { flag } = action.payload;
                return Object.assign(Object.assign({}, state), { transportGeofenceView: flag });
            }
            case 'MAP_SET_TRANSPORT_TAB': {
                const { value } = action.payload;
                return Object.assign(Object.assign({}, state), { transportTab: value, transportSelectedItem: state.transportSelectedItem
                        ? Object.assign(Object.assign({}, state.transportSelectedItem), { conditionOptions: Object.assign(Object.assign({}, state.transportSelectedItem.conditionOptions), { open: false }), parkingPointsOptions: Object.assign(Object.assign({}, state.transportSelectedItem.parkingPointsOptions), { open: false }) }) : state.transportSelectedItem });
            }
            case 'MAP_SET_FILTER_TAB': {
                const { value } = action.payload;
                return Object.assign(Object.assign({}, state), { filterTab: value });
            }
            case 'MAP_SET_TRANSPORT_ITEMS': {
                const { items } = action.payload;
                const selectedItem = state.transportSelectedItem ? items.find((item) => { var _a; return item.id === ((_a = state.transportSelectedItem) === null || _a === void 0 ? void 0 : _a.id); }) : undefined;
                return Object.assign(Object.assign({}, state), { transportSelectedItem: state.transportSelectedItem && selectedItem
                        ? Object.assign(Object.assign({}, state.transportSelectedItem), { last_activity_date: selectedItem.last_activity_date, last_motion_galileosky_date: selectedItem.last_motion_galileosky_date }) : state.transportSelectedItem, transportItems: items.map((value) => {
                        const itemConditions = Array.isArray(value.conditions) ? value.conditions : [];
                        return Object.assign(Object.assign({}, value), { conditions: itemConditions.length !== 0
                                ? itemConditions.map((currentCondition, index, array) => {
                                    let previousIndex = index--;
                                    let previousCondition = array[previousIndex];
                                    return {
                                        type: 'message',
                                        datetime: moment.utc(currentCondition.datetime).local().format('YYYY-MM-DD HH:mm:ss'),
                                        receive_date: moment.utc(currentCondition.receive_date).local().format('YYYY-MM-DD HH:mm:ss'),
                                        data: currentCondition,
                                        filters: value.filters,
                                        messages: transportGenerateConditionMessages(currentCondition, previousCondition ? previousCondition : undefined),
                                    };
                                })
                                : [] });
                    }), transportCheckedItems: items.reduce(function (accumulator, currentValue) {
                        if (state.transportCheckedItems.includes(currentValue.id)) {
                            accumulator.push(currentValue.id);
                        }
                        return accumulator;
                    }, []) });
            }
            case 'MAP_SET_TRANSPORT_SELECTED_ITEM': {
                const { data } = action.payload;
                if (!data) {
                    return Object.assign(Object.assign({}, state), { transportTab: 'condition', transportSelectedItem: null, transportBroadcastSelectedItem: null, transportConditionSelectedItem: null, transportConditionSelectedDatetime: null });
                }
                if (data.id === ((_c = state.transportSelectedItem) === null || _c === void 0 ? void 0 : _c.id)) {
                    return Object.assign(Object.assign({}, state), { transportSelectedItem: Object.assign(Object.assign({}, state.transportSelectedItem), { name: data.name, number: data.number, number_country: data.number_country, vin: data.vin, volume: data.volume, type_id: data.type_id, model_id: data.model_id, comment: data.comment, group_id: data.group_id, group_name: data.group_name, group_type: data.group_type, color: data.color, tank: data.tank, trailer_id: data.trailer_id, trailer_number: data.trailer_number, trailer_vin: data.trailer_vin, trailer_dun_cover: data.trailer_dun_cover, trailer_fuel_level_sensor: data.trailer_fuel_level_sensor, fuel_availability_sensor: data.fuel_availability_sensor, drain_sensor: data.drain_sensor, ground_sensor: data.ground_sensor, dun_cover: (_d = data.dun_cover) !== null && _d !== void 0 ? _d : data.trailer_dun_cover, imei: data.imei, device_type: data.device_type, sim0: data.sim0, sim1: data.sim1, wialon_type: data.wialon_type, wialon_imei: data.wialon_imei }) });
                }
                const newState = Object.assign(Object.assign({}, state), { transportSelectedItem: Object.assign(Object.assign({}, data), { broadcast: {
                            vendor: null,
                            deviceId: '',
                            terid: '',
                            channels: [],
                            events: [],
                            previousEvents: [],
                            previousRecords: [],
                            online: true,
                        }, tasks: [], conditions: [], conditionOptions: {
                            open: false,
                            visible: false,
                            interval: config.mapTransportTrackInterval[config.mapTransportTrackInterval.length - 1],
                        }, parkingPointsOptions: {
                            open: false,
                            visible: false,
                            interval: config.mapTransportTrackInterval[config.mapTransportTrackInterval.length - 1],
                        } }), transportBroadcastSelectedItem: 1, transportConditionSelectedItem: Array.isArray(data.conditions) && data.conditions.length !== 0 ? data.conditions[data.conditions.length - 1] : null });
                if (state.isHistoryOpen && Array.isArray(data.conditions) && data.conditions.length !== 0) {
                    const activeCondition = data.conditions.filter((condition) => moment(condition.datetime).isSameOrBefore(state.historySelectedTime)).at(-1);
                    newState.transportConditionSelectedItem = activeCondition;
                }
                return newState;
            }
            case 'MAP_SET_TRANSPORT_SELECTED_DATE': {
                const { value } = action.payload;
                return Object.assign(Object.assign({}, state), { transportSelectedItem: state.transportSelectedItem
                        ? Object.assign(Object.assign({}, state.transportSelectedItem), { conditions: [], broadcast: Object.assign(Object.assign({}, state.transportSelectedItem.broadcast), { events: [], previousEvents: [], previousRecords: [] }) }) : state.transportSelectedItem, transportBroadcastSelectedItem: 1, transportConditionSelectedItem: null, transportConditionSelectedDatetime: state.transportConditionSelectedDatetime && moment(state.transportConditionSelectedDatetime).isBetween(moment(value[0]), moment(value[1]), null, '[]') ? state.transportConditionSelectedDatetime : null, transportSelectedDate: moment().isSameOrBefore(value[1])
                        ? [moment(value[0]).startOf('day').format('YYYY-MM-DD HH:mm:ss'), moment(value[1]).endOf('day').format('YYYY-MM-DD HH:mm:ss')]
                        : [moment(value[0]).format('YYYY-MM-DD HH:mm:ss'), moment(value[1]).format('YYYY-MM-DD HH:mm:ss')] });
            }
            case 'MAP_SET_TRANSPORT_FILTER_CHECKED_TYPE': {
                const { value } = action.payload;
                return Object.assign(Object.assign({}, state), { transportFilterCheckedType: value });
            }
            case 'MAP_SET_TRANSPORT_CHECKED_ITEM_TASK': {
                const { data } = action.payload;
                return Object.assign(Object.assign({}, state), { transportItems: state.transportItems.map((transportItem) => {
                        if (transportItem.id !== data.transport_id) {
                            return transportItem;
                        }
                        return Object.assign(Object.assign({}, transportItem), { task: data });
                    }) });
            }
            case 'MAP_SET_TRANSPORT_CHECKED_ITEM': {
                const { items } = action.payload;
                switch (state.transportFilterCheckedType) {
                    case 'filter':
                        return Object.assign(Object.assign({}, state), { transportProcessingCheckedItems: items });
                    case 'all':
                        return Object.assign(Object.assign({}, state), { transportCheckedItems: items });
                }
            }
            case 'MAP_ADD_TRANSPORT_CHECKED_ITEM': {
                const { id } = action.payload;
                switch (state.transportFilterCheckedType) {
                    case 'filter':
                        return Object.assign(Object.assign({}, state), { transportMarkedCheckedItems: state.transportMarkedCheckedItems.filter((checkedId) => checkedId !== id), transportProcessingCheckedItems: [...state.transportProcessingCheckedItems, id] });
                    case 'all':
                        return Object.assign(Object.assign({}, state), { transportCheckedItems: [...state.transportCheckedItems, id] });
                }
            }
            case 'MAP_DELETE_TRANSPORT_CHECKED_ITEM': {
                const { id } = action.payload;
                switch (state.transportFilterCheckedType) {
                    case 'filter':
                        return Object.assign(Object.assign({}, state), { transportMarkedCheckedItems: [...state.transportMarkedCheckedItems, id], transportProcessingCheckedItems: state.transportProcessingCheckedItems.filter((checkedId) => checkedId !== id) });
                    case 'all':
                        return Object.assign(Object.assign({}, state), { transportCheckedItems: state.transportCheckedItems.filter((checkedId) => checkedId !== id) });
                }
            }
            case 'MAP_SET_TRANSPORT_MARKED_CHECKED_ITEM': {
                const { items } = action.payload;
                return Object.assign(Object.assign({}, state), { transportMarkedCheckedItems: items });
            }
            case 'MAP_SET_TRANSPORT_SORT_SELECTED_ITEM': {
                const { data } = action.payload;
                return Object.assign(Object.assign({}, state), { transportSortSelectedItem: {
                        name: data.name,
                        order: state.transportSortSelectedItem.name !== data.name ? data.order : state.transportSortSelectedItem.order === 'ASC' ? 'DESC' : 'ASC',
                    } });
            }
            case 'MAP_ADD_TRANSPORT_FILTER_CHECKED_ITEM': {
                const { value } = action.payload;
                return Object.assign(Object.assign({}, state), { transportFilterCheckedItems: [...state.transportFilterCheckedItems, value] });
            }
            case 'MAP_DELETE_TRANSPORT_FILTER_CHECKED_ITEM': {
                const { value } = action.payload;
                return Object.assign(Object.assign({}, state), { transportFilterCheckedItems: state.transportFilterCheckedItems.filter((transportFilterCheckedItem) => transportFilterCheckedItem !== value) });
            }
            case 'MAP_SET_TRANSPORT_FILTER_CHECKED_ITEMS': {
                const { items } = action.payload;
                return Object.assign(Object.assign({}, state), { transportFilterCheckedItems: items });
            }
            case 'MAP_ADD_TRANSPORT_COLUMN_CHECKED_ITEM': {
                const { value } = action.payload;
                return Object.assign(Object.assign({}, state), { transportColumnCheckedItems: [...state.transportColumnCheckedItems, value] });
            }
            case 'MAP_DELETE_TRANSPORT_COLUMN_CHECKED_ITEM':
                // eslint-disable-next-line no-case-declarations
                const { value } = action.payload;
                return Object.assign(Object.assign({}, state), { transportColumnCheckedItems: state.transportColumnCheckedItems.filter((transportColumnCheckedItem) => transportColumnCheckedItem !== value) });
            case 'MAP_SET_TRANSPORT_CONDITION_CHECKED_TYPE': {
                const { value } = action.payload;
                return Object.assign(Object.assign({}, state), { transportConditionFilterCheckedType: value });
            }
            case 'MAP_SET_TRANSPORT_CONDITION_CHECKED_ITEM': {
                const { items } = action.payload;
                return Object.assign(Object.assign({}, state), { transportConditionFilterCheckedItems: items });
            }
            case 'MAP_ADD_TRANSPORT_CONDITION_CHECKED_ITEM': {
                const { items } = action.payload;
                return Object.assign(Object.assign({}, state), { transportConditionFilterCheckedItems: [...state.transportConditionFilterCheckedItems, ...items] });
            }
            case 'MAP_DELETE_TRANSPORT_CONDITION_CHECKED_ITEM': {
                const { items } = action.payload;
                return Object.assign(Object.assign({}, state), { transportConditionFilterCheckedItems: state.transportConditionFilterCheckedItems.reduce((acc, item) => {
                        if (!items.includes(item)) {
                            acc.push(item);
                        }
                        return acc;
                    }, []) });
            }
            case 'MAP_SET_TRANSPORT_SEARCH_VALUE': {
                const { value } = action.payload;
                return Object.assign(Object.assign({}, state), { transportSearchValue: value });
            }
            case 'MAP_SET_TRANSPORT_ITEMS_ACTIVITY': {
                const { data } = action.payload;
                return Object.assign(Object.assign({}, state), { transportItems: state.transportItems.map((transportItem) => {
                        if (transportItem.id !== data.transport_id) {
                            return transportItem;
                        }
                        if (transportItem.wialon_type !== 2 && !transportItem.wialon_imei) {
                            return transportItem;
                        }
                        return Object.assign(Object.assign({}, transportItem), { last_activity_date: moment.utc(data.last_activity_date).local().format('YYYY-MM-DD HH:mm:ss') });
                    }), transportSelectedItem: ((_e = state.transportSelectedItem) === null || _e === void 0 ? void 0 : _e.id) === data.transport_id && (state.transportSelectedItem.wialon_type === 2 || state.transportSelectedItem.wialon_imei)
                        ? Object.assign(Object.assign({}, state.transportSelectedItem), { last_activity_date: moment.utc(data.last_activity_date).local().format('YYYY-MM-DD HH:mm:ss') }) : state.transportSelectedItem });
            }
            case 'MAP_ADD_TRANSPORT_ITEMS_CONDITION': {
                const _x = action.payload.data, { filters = [] } = _x, data = __rest(_x, ["filters"]);
                return Object.assign(Object.assign({}, state), { transportItems: state.transportItems.map((transportItem) => {
                        var _a;
                        if (transportItem.id !== data.transport_id) {
                            return transportItem;
                        }
                        return Object.assign(Object.assign({}, transportItem), { last_motion_galileosky_date: resolveNextMotionGalileoskyDate({
                                canSpeed: data.can_speed,
                                candidateDatetime: data.datetime,
                                currentDatetime: transportItem.last_motion_galileosky_date,
                            }), conditions: Array.isArray(transportItem.conditions) && transportItem.conditions.length !== 0
                                ? moment
                                    .utc(data.datetime)
                                    .local()
                                    .isAfter(transportItem.conditions[transportItem.conditions.length - 1].datetime)
                                    ? [
                                        transportItem.conditions[transportItem.conditions.length - 1],
                                        {
                                            type: 'message',
                                            datetime: moment.utc(data.datetime).local().format('YYYY-MM-DD HH:mm:ss'),
                                            receive_date: moment.utc(data.receive_date).local().format('YYYY-MM-DD HH:mm:ss'),
                                            data: data,
                                            filters: filters,
                                            messages: transportGenerateConditionMessages(data, (_a = transportItem.conditions[transportItem.conditions.length - 1]) === null || _a === void 0 ? void 0 : _a.data),
                                        },
                                    ]
                                    : transportItem.conditions
                                : [
                                    {
                                        type: 'message',
                                        datetime: moment.utc(data.datetime).local().format('YYYY-MM-DD HH:mm:ss'),
                                        receive_date: moment.utc(data.receive_date).local().format('YYYY-MM-DD HH:mm:ss'),
                                        data: data,
                                        filters: filters,
                                        messages: transportGenerateConditionMessages(data),
                                    },
                                ] });
                    }), transportSelectedItem: state.transportSelectedItem
                        ? state.transportSelectedItem.id !== data.transport_id
                            ? state.transportSelectedItem
                            : moment(state.transportSelectedDate[1]).isSameOrAfter(moment.utc(data.datetime).local(), 'day')
                                ? Object.assign(Object.assign({}, state.transportSelectedItem), { last_motion_galileosky_date: resolveNextMotionGalileoskyDate({
                                        canSpeed: data.can_speed,
                                        candidateDatetime: data.datetime,
                                        currentDatetime: state.transportSelectedItem.last_motion_galileosky_date,
                                    }), conditions: Array.isArray(state.transportSelectedItem.conditions) && state.transportSelectedItem.conditions.length !== 0
                                        ? state.transportSelectedItem.conditions.findIndex((condition) => moment(condition.datetime).isSame(moment.utc(data.datetime).local())) !== -1
                                            ? state.transportSelectedItem.conditions
                                            : [
                                                ...state.transportSelectedItem.conditions,
                                                {
                                                    type: 'message',
                                                    datetime: moment.utc(data.datetime).local().format('YYYY-MM-DD HH:mm:ss'),
                                                    receive_date: moment.utc(data.receive_date).local().format('YYYY-MM-DD HH:mm:ss'),
                                                    data: data,
                                                    messages: transportGenerateConditionMessages(data, (_f = state.transportSelectedItem.conditions.filter((condition) => condition.type === 'message').pop()) === null || _f === void 0 ? void 0 : _f.data),
                                                },
                                            ].sort((a, b) => moment(a.datetime).valueOf() - moment(b.datetime).valueOf())
                                        : state.transportSelectedItem.conditions }) : state.transportSelectedItem
                        : null, transportConditionSelectedItem: state.transportSelectedItem
                        ? state.transportSelectedItem.id !== data.transport_id
                            ? state.transportConditionSelectedItem
                            : moment(state.transportSelectedDate[1]).isSameOrAfter(moment.utc(data.datetime).local(), 'day')
                                ? Array.isArray(state.transportSelectedItem.conditions) && state.transportSelectedItem.conditions.length !== 0
                                    ? state.transportConditionSelectedItem && moment(state.transportConditionSelectedItem.datetime).isSame((_g = state.transportSelectedItem.conditions.filter((condition) => condition.type === 'message').pop()) === null || _g === void 0 ? void 0 : _g.datetime)
                                        ? moment
                                            .utc(data.datetime)
                                            .local()
                                            .isAfter((_h = state.transportSelectedItem.conditions.filter((condition) => condition.type === 'message').pop()) === null || _h === void 0 ? void 0 : _h.datetime)
                                            ? {
                                                type: 'message',
                                                datetime: moment.utc(data.datetime).local().format('YYYY-MM-DD HH:mm:ss'),
                                                receive_date: moment.utc(data.receive_date).local().format('YYYY-MM-DD HH:mm:ss'),
                                                data: data,
                                                hdopData: null,
                                                messages: transportGenerateConditionMessages(data, (_j = state.transportSelectedItem.conditions.filter((condition) => condition.type === 'message').pop()) === null || _j === void 0 ? void 0 : _j.data),
                                            }
                                            : state.transportConditionSelectedItem
                                        : state.transportConditionSelectedItem
                                    : null
                                : state.transportConditionSelectedItem
                        : null });
            }
            case 'MAP_ADD_TRANSPORT_ITEMS_COMMAND': {
                const { data } = action.payload;
                const { transportSelectedItem, transportSelectedDate } = state;
                // Если нет выбранного элемента - выход
                if (!transportSelectedItem)
                    return Object.assign({}, state);
                // Проверка ID транспорта
                const transportId = Number(data.transport_id);
                if (transportSelectedItem.id !== transportId)
                    return Object.assign({}, state);
                // Проверка на вхождение в диапазон
                const commandDate = parseDate(data.datetime);
                const rangeStart = parseDate(transportSelectedDate[0]);
                const rangeEnd = parseDate(transportSelectedDate[1]);
                if (!commandDate.isValid() || !rangeStart.isValid() || !rangeEnd.isValid()) {
                    return state;
                }
                if (!isInRange(commandDate, rangeStart, rangeEnd)) {
                    return state;
                }
                // Проверка существующей команды
                const hasExistingCommand = ((_k = transportSelectedItem.conditions) !== null && _k !== void 0 ? _k : []).some((c) => c.datetime === commandDate.format('YYYY-MM-DD HH:mm:ss'));
                if (hasExistingCommand)
                    return Object.assign({}, state);
                // Создание новой команды
                const newCommand = {
                    type: 'command',
                    datetime: commandDate.local().format('YYYY-MM-DD HH:mm:ss'),
                    receive_date: moment.utc(data.receive_date).local().format('YYYY-MM-DD HH:mm:ss'),
                    data,
                    messages: transportGenerateConditionMessages(data),
                };
                return Object.assign(Object.assign({}, state), { transportSelectedItem: Object.assign(Object.assign({}, transportSelectedItem), { conditions: [...transportSelectedItem.conditions, newCommand].sort((a, b) => parseDate(a.datetime).valueOf() - parseDate(b.datetime).valueOf()) }) });
            }
            case 'MAP_SET_TRANSPORT_SELECTED_ITEM_CONDITIONS': {
                const items = Array.isArray(action.payload.items) ? action.payload.items : [];
                if (((_l = state.transportSelectedItem) === null || _l === void 0 ? void 0 : _l.id) !== ((_m = items.at(0)) === null || _m === void 0 ? void 0 : _m.transport_id)) {
                    return Object.assign({}, state);
                }
                const newState = Object.assign(Object.assign({}, state), { transportSelectedItem: state.transportSelectedItem
                        ? Object.assign(Object.assign({}, state.transportSelectedItem), { conditions: items.length === 0
                                ? items
                                : items.map((currentCondition, index, array) => {
                                    let previousIndex = index;
                                    let previousCondition;
                                    while (previousIndex >= 0) {
                                        previousIndex--;
                                        if (array[previousIndex] && !array[previousIndex].hasOwnProperty('cmd_id')) {
                                            previousCondition = array[previousIndex];
                                            break;
                                        }
                                    }
                                    return {
                                        type: currentCondition.hasOwnProperty('cmd_id') ? 'command' : 'message',
                                        datetime: moment.utc(currentCondition.datetime).local().format('YYYY-MM-DD HH:mm:ss'),
                                        receive_date: moment.utc(currentCondition.receive_date).local().format('YYYY-MM-DD HH:mm:ss'),
                                        data: currentCondition,
                                        messages: transportGenerateConditionMessages(currentCondition, previousCondition ? previousCondition : items[0].hasOwnProperty('cmd_id') ? undefined : items[0]),
                                    };
                                }) }) : null, transportConditionSelectedItem: state.transportSelectedItem
                        ? items.length !== 0
                            ? items
                                .filter((currentCondition) => !currentCondition.hasOwnProperty('cmd_id'))
                                .map((currentCondition, index, array) => {
                                let previousIndex = index;
                                let previousCondition;
                                while (previousIndex >= 0) {
                                    previousIndex--;
                                    if (array[previousIndex] && !array[previousIndex].hasOwnProperty('cmd_id')) {
                                        previousCondition = array[previousIndex];
                                        break;
                                    }
                                }
                                return {
                                    type: currentCondition.hasOwnProperty('cmd_id') ? 'command' : 'message',
                                    datetime: moment.utc(currentCondition.datetime).local().format('YYYY-MM-DD HH:mm:ss'),
                                    receive_date: moment.utc(currentCondition.receive_date).local().format('YYYY-MM-DD HH:mm:ss'),
                                    data: currentCondition,
                                    hdopData: null,
                                    messages: transportGenerateConditionMessages(currentCondition, previousCondition ? previousCondition : items[0].hasOwnProperty('cmd_id') ? undefined : items[0]),
                                };
                            })
                                .pop()
                            : null
                        : null });
                if (state.isHistoryOpen && items.length !== 0) {
                    const activeCondition = items
                        .filter((currentCondition) => !currentCondition.hasOwnProperty('cmd_id'))
                        .filter((condition) => moment.utc(condition.datetime).local().isSameOrBefore(state.historySelectedTime))
                        .at(-1);
                    if (activeCondition) {
                        newState.transportConditionSelectedItem = Object.assign(Object.assign({}, activeCondition), { type: activeCondition.hasOwnProperty('cmd_id') ? 'command' : 'message', datetime: moment.utc(activeCondition.datetime).local().format('YYYY-MM-DD HH:mm:ss'), receive_date: moment.utc(activeCondition.receive_date).local().format('YYYY-MM-DD HH:mm:ss'), data: activeCondition, hdopData: null, messages: transportGenerateConditionMessages(activeCondition, items[0].hasOwnProperty('cmd_id') ? undefined : items[0]) });
                    }
                }
                return newState;
            }
            case 'MAP_SET_TRANSPORT_CONDITION_SELECTED_DATETIME': {
                const { datetime } = action.payload;
                return Object.assign(Object.assign({}, state), { transportConditionSelectedDatetime: datetime });
            }
            case 'MAP_SET_TRANSPORT_BROADCAST_SELECTED_ITEM': {
                const { data } = action.payload;
                return Object.assign(Object.assign({}, state), { transportBroadcastSelectedItem: data });
            }
            case 'MAP_SET_TRANSPORT_SELECTED_ITEM_BROADCAST': {
                const { data } = action.payload;
                const channels = data === null || data === void 0 ? void 0 : data.channels;
                const currentChannel = state.transportBroadcastSelectedItem;
                const channelStillValid = Array.isArray(channels) && channels.some((channel) => channel.id === currentChannel);
                return Object.assign(Object.assign({}, state), { transportBroadcastSelectedItem: data ? (channelStillValid ? currentChannel : ((_p = (_o = channels === null || channels === void 0 ? void 0 : channels[0]) === null || _o === void 0 ? void 0 : _o.id) !== null && _p !== void 0 ? _p : 1)) : state.transportBroadcastSelectedItem, transportSelectedItem: state.transportSelectedItem
                        ? Object.assign(Object.assign({}, state.transportSelectedItem), { broadcast: data
                                ? Object.assign(Object.assign({}, data), { previousEvents: [], previousRecords: [] }) : state.transportSelectedItem.broadcast }) : null });
            }
            case 'MAP_SET_TRANSPORT_BROADCAST_RECORDS': {
                const { terid, events, records } = action.payload;
                const currentId = (_s = (_r = (_q = state.transportSelectedItem) === null || _q === void 0 ? void 0 : _q.broadcast) === null || _r === void 0 ? void 0 : _r.deviceId) !== null && _s !== void 0 ? _s : (_u = (_t = state.transportSelectedItem) === null || _t === void 0 ? void 0 : _t.broadcast) === null || _u === void 0 ? void 0 : _u.terid;
                return Object.assign(Object.assign({}, state), { transportSelectedItem: state.transportSelectedItem
                        ? currentId === terid
                            ? Object.assign(Object.assign({}, state.transportSelectedItem), { broadcast: Object.assign(Object.assign({}, state.transportSelectedItem.broadcast), { previousEvents: events, previousRecords: records }) }) : state.transportSelectedItem
                        : null });
            }
            case 'MAP_SET_TRANSPORT_CONDITION_SELECTED_ITEM': {
                const { data } = action.payload;
                const newState = Object.assign(Object.assign({}, state), { transportTab: state.transportTab !== 'event' ? state.transportTab : 'condition', transportConditionSelectedItem: data, transportConditionSelectedDatetime: state.transportConditionSelectedDatetime ? state.transportConditionSelectedDatetime : null });
                if (state.isHistoryOpen && (data === null || data === void 0 ? void 0 : data.datetime)) {
                    newState.historySelectedTime = data.datetime;
                }
                return newState;
            }
            case 'MAP_SET_TRANSPORT_SELECTED_ITEM_CONDITION_OPTIONS': {
                const { data } = action.payload;
                if (!state.transportSelectedItem) {
                    return state;
                }
                return Object.assign(Object.assign({}, state), { transportSelectedItem: Object.assign(Object.assign({}, state.transportSelectedItem), { conditionOptions: data }) });
            }
            case 'MAP_SET_TRANSPORT_SELECTED_ITEM_PARKING_POINTS_OPTIONS': {
                const { data } = action.payload;
                if (!state.transportSelectedItem) {
                    return state;
                }
                return Object.assign(Object.assign({}, state), { transportSelectedItem: Object.assign(Object.assign({}, state.transportSelectedItem), { parkingPointsOptions: data }) });
            }
            case 'MAP_SET_GEOFENCE_SEARCH_VALUE': {
                const { value } = action.payload;
                return Object.assign(Object.assign({}, state), { geofenceSearchValue: value });
            }
            case 'MAP_ADD_GEOFENCE': {
                const { data } = action.payload;
                return Object.assign(Object.assign({}, state), { geofenceItems: [...state.geofenceItems, data], geofenceGroupItems: state.geofenceGroupItems.map((item) => {
                        if (item.id !== data.group_id) {
                            return item;
                        }
                        return Object.assign(Object.assign({}, item), { geofences: [
                                ...item.geofences,
                                {
                                    id: data.id,
                                    name: data.name,
                                    latitude: data.latitude,
                                    longitude: data.longitude,
                                },
                            ].sort((a, b) => a.name.localeCompare(b.name, { sensitivity: 'base' })) });
                    }) });
            }
            case 'MAP_UPDATE_GEOFENCE': {
                const { id, data } = action.payload;
                return Object.assign(Object.assign({}, state), { geofenceItems: state.geofenceItems.map((geofenceItem) => {
                        if (geofenceItem.id !== id) {
                            return geofenceItem;
                        }
                        return Object.assign(Object.assign({}, geofenceItem), data);
                    }) });
            }
            case 'GEOFENCE_GROUP_UPDATE_ITEM': {
                const { data } = action.payload;
                return Object.assign(Object.assign({}, state), { geofenceItems: state.geofenceItems.map((geofenceItem) => {
                        if (geofenceItem.group_id !== data.id) {
                            return geofenceItem;
                        }
                        return Object.assign(Object.assign({}, geofenceItem), { color: data.color });
                    }) });
            }
            case 'MAP_DELETE_GEOFENCE': {
                const { id } = action.payload;
                return Object.assign(Object.assign({}, state), { geofenceItems: state.geofenceItems.filter((geofenceItem) => geofenceItem.id !== id) });
            }
            case 'MAP_SET_GEOFENCE_UPDATED_ITEM': {
                const { data } = action.payload;
                return Object.assign(Object.assign({}, state), { geofenceUpdatedItem: data, geofenceUpdatedMode: data ? (data.hasOwnProperty('leafletId') ? 'create' : data.hasOwnProperty('delete') ? 'delete' : 'update') : state.geofenceUpdatedMode });
            }
            case 'MAP_SET_GEOFENCE_CHANGED_ITEM': {
                const { data } = action.payload;
                return Object.assign(Object.assign({}, state), { geofenceChangedItem: data });
            }
            case 'MAP_SET_GEOFENCE_CHECKED_ID': {
                const { items } = action.payload;
                return Object.assign(Object.assign({}, state), { geofenceCheckedId: items });
            }
            case 'MAP_ADD_GEOFENCES_CHECKED_ID': {
                const { items } = action.payload;
                return Object.assign(Object.assign({}, state), { geofenceCheckedId: [...state.geofenceCheckedId, ...items] });
            }
            case 'MAP_ADD_GEOFENCE_CHECKED_ID': {
                const { id } = action.payload;
                return Object.assign(Object.assign({}, state), { geofenceCheckedId: [...state.geofenceCheckedId, id] });
            }
            case 'MAP_DELETE_GEOFENCE_CHECKED_ID': {
                const { id } = action.payload;
                return Object.assign(Object.assign({}, state), { geofenceCheckedId: state.geofenceCheckedId.filter((checkedId) => checkedId !== id) });
            }
            case 'MAP_SET_GEOFENCE_GROUP_ITEMS': {
                const { items } = action.payload;
                return Object.assign(Object.assign({}, state), { geofenceGroupItems: items, geofenceItems: items.reduce((accumulator, currentValue) => {
                        return [...accumulator, ...currentValue.geofences];
                    }, []) });
            }
            case 'MAP_SET_TASK': {
                const { data } = action.payload;
                return Object.assign(Object.assign({}, state), { taskItems: Array.isArray(data) ? data : [] });
            }
            case 'MAP_SET_TASK_SEARCH_VALUE': {
                const { value } = action.payload;
                return Object.assign(Object.assign({}, state), { taskSearchValue: value });
            }
            case 'MAP_SET_TASK_SORT_SELECTED_ITEM': {
                const { data } = action.payload;
                return Object.assign(Object.assign({}, state), { taskSortSelectedItem: {
                        name: data.name,
                        order: state.taskSortSelectedItem.name !== data.name ? data.order : state.taskSortSelectedItem.order === 'ASC' ? 'DESC' : 'ASC',
                    } });
            }
            case 'MAP_ADD_TASK_FILTER_CHECKED_ITEM': {
                const { value } = action.payload;
                return Object.assign(Object.assign({}, state), { taskFilterCheckedItems: [...state.taskFilterCheckedItems, value] });
            }
            case 'MAP_DELETE_TASK_FILTER_CHECKED_ITEM': {
                const { value } = action.payload;
                return Object.assign(Object.assign({}, state), { taskFilterCheckedItems: state.taskFilterCheckedItems.filter((taskFilterCheckedItem) => taskFilterCheckedItem !== value) });
            }
            case 'MAP_ADD_TASK_COLUMN_CHECKED_ITEM': {
                const { value } = action.payload;
                return Object.assign(Object.assign({}, state), { taskColumnCheckedItems: [...state.taskColumnCheckedItems, value] });
            }
            case 'MAP_DELETE_TASK_COLUMN_CHECKED_ITEM': {
                const { value } = action.payload;
                return Object.assign(Object.assign({}, state), { taskColumnCheckedItems: state.taskColumnCheckedItems.filter((taskColumnCheckedItem) => taskColumnCheckedItem !== value) });
            }
            case 'MAP_SET_TASK_SELECTED_ITEM': {
                const { data } = action.payload;
                return Object.assign(Object.assign({}, state), { taskSelectedItem: data });
            }
            case 'SESSION_SET_DATA': {
                const { session } = action.payload;
                if (!session) {
                    return Object.assign({}, state);
                }
                return Object.assign(Object.assign({}, state), { transportSortSelectedItem: session.permissions.includes('activity')
                        ? {
                            name: config.mapTransportColumns[7].name,
                            order: 'DESC',
                        }
                        : state.transportSortSelectedItem, transportFilterCheckedItems: session.permissions.includes('activity') ? config.mapTransportFilters.map((filter) => filter.name) : state.transportFilterCheckedItems, transportColumnCheckedItems: session.permissions.includes('activity') ? config.mapTransportColumns.map((column) => column.name) : state.transportColumnCheckedItems });
            }
            case 'MAP_SET_TRANSPORT_CONDITION_HDOP': {
                const { value } = action.payload;
                if (((_v = state.transportSelectedItem) === null || _v === void 0 ? void 0 : _v.id) !== (value === null || value === void 0 ? void 0 : value.transport_id)) {
                    return Object.assign({}, state);
                }
                return Object.assign(Object.assign({}, state), { transportConditionSelectedItem: !state.transportConditionSelectedItem
                        ? state.transportConditionSelectedItem
                        : state.transportConditionSelectedItem.datetime !== value.datetime
                            ? state.transportConditionSelectedItem
                            : Object.assign(Object.assign({}, state.transportConditionSelectedItem), { hdopData: value }) });
            }
            case 'MAP_SET_TRANSPORT_SELECTED_ITEM_TASK': {
                const { value } = action.payload;
                if (((_w = state.transportSelectedItem) === null || _w === void 0 ? void 0 : _w.id) !== (value === null || value === void 0 ? void 0 : value.transport_id)) {
                    return Object.assign({}, state);
                }
                return Object.assign(Object.assign({}, state), { transportSelectedItem: Object.assign(Object.assign({}, state.transportSelectedItem), { tasks: (value === null || value === void 0 ? void 0 : value.ttn_task) || [] }) });
            }
            default:
                return state;
        }
    }
    catch (e) {
        console.error('[REDUCER ERROR]', action.type, e);
        return state;
    }
}
function transportGenerateConditionMessages(condition, previousCondition = undefined) {
    const messages = [];
    if (condition.hasOwnProperty('cmd_id')) {
        config.compareEvents['command'].forEach(function (event) {
            if (event.key === condition.name) {
                messages.push({
                    name: 'command',
                    key: event.key,
                    body: event.message,
                });
            }
            if (event.key.includes('9999') && condition.name.includes(event.key)) {
                messages.push({
                    name: 'command',
                    key: event.key,
                    body: event.message.concat(': ').concat(condition.name
                        .split(',9999,')[1]
                        .split(',')
                        .map(Number)
                        .map((ns, key) => (ns === 0 ? key + 1 : null))
                        .filter((x) => x !== null)),
                });
            }
        });
        return messages;
    }
    Object.entries(condition).forEach(function ([name, value]) {
        if (config.compareEvents.hasOwnProperty(name)) {
            config.compareEvents[name].forEach(function (event) {
                if (event.compare[0](value)) {
                    if (previousCondition === undefined) {
                        if (name === 'geofence_id') {
                            return;
                        }
                    }
                    if (previousCondition === undefined || event.compare[1](value, previousCondition[name])) {
                        messages.push({
                            name: name,
                            key: event.key,
                            body: event.message,
                            value: value,
                        });
                        if (name === 'geofence_id') {
                            messages[messages.length - 1].value = value !== 0 ? condition.geofence_name : previousCondition ? previousCondition.geofence_name : 0;
                        }
                    }
                }
            });
        }
    });
    return messages;
}
export function transportLoad() {
    return function transportLoadThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.get('/map/transport');
            return dispatch(actions.setTransportItems(data));
        });
    };
}
export function transportBroadcastLoad(id) {
    return function transportBroadcastLoadThunk(dispatch, getState) {
        return __awaiter(this, void 0, void 0, function* () {
            const [from, to] = getState().map.transportSelectedDate;
            const { data } = yield http.get(`/map/transport/${id}/broadcast?from=${from}&to=${to}&timezone=${getState().session.timezone}`);
            return dispatch(actions.setTransportSelectedItemBroadcast(data));
        });
    };
}
export function transportBroadcastRecordLoad() {
    return function transportBroadcastRecordLoadThunk(dispatch, getState) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            const item = getState().map.transportSelectedItem;
            if (!(item === null || item === void 0 ? void 0 : item.id)) {
                return;
            }
            const from = moment().startOf('month').format('YYYY-MM-DD HH:mm:ss');
            const to = moment().endOf('month').format('YYYY-MM-DD HH:mm:ss');
            const deviceId = (_b = (_a = item.broadcast) === null || _a === void 0 ? void 0 : _a.deviceId) !== null && _b !== void 0 ? _b : (_c = item.broadcast) === null || _c === void 0 ? void 0 : _c.terid;
            const { data } = yield http.get(`/map/transport/${item.id}/broadcast/record?from=${from}&to=${to}&timezone=${getState().session.timezone}`);
            return dispatch(actions.setTransportBroadcastRecords(deviceId, data.events, data.records));
        });
    };
}
export function transportConditionLoad(id) {
    return function transportConditionLoadThunk(dispatch, getState) {
        return __awaiter(this, void 0, void 0, function* () {
            const [from, to] = getState().map.transportSelectedDate;
            const { data } = yield http.get(`/map/transport/${id}/condition?from=${from}&to=${to}&timezone=${getState().session.timezone}`);
            return dispatch(actions.setTransportSelectedItemConditions(data));
        });
    };
}
export function transportHistoryTracksItemsLoad() {
    return function transportConditionLoadListThunk(dispatch, getState) {
        return __awaiter(this, void 0, void 0, function* () {
            let { transportSelectedDate, transportCheckedItems, transportSelectedItem } = getState().map;
            const [from, to] = transportSelectedDate;
            const timezone = getState().session.timezone;
            let list = transportCheckedItems || [];
            if (!list.length && transportSelectedItem) {
                list.push(transportSelectedItem.id);
            }
            if (!list.length) {
                return;
            }
            const results = yield http.get(`/map/transport/conditions?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}&timezone=${timezone}&list=${list}`);
            if (results.data) {
                return dispatch(actions.setTransportHistoryTracksItems(results.data));
            }
        });
    };
}
/**
 * Загрузка истории транспорта с использованием WebWorker + SSE
 * Загружает данные в фоновом режиме, сохраняет в IndexedDB и обновляет UI
 * @param {boolean} forceRefresh - Если true, очищает кэш и загружает данные с сервера
 */
// Максимальное количество транспортов в одном запросе (ограничение URL и сервера)
const MAX_TRANSPORTS_PER_REQUEST = 100;
export function transportHistoryTracksItemsLoadStream(forceRefresh = false) {
    return function transportHistoryTracksItemsLoadStreamThunk(dispatch, getState) {
        return __awaiter(this, void 0, void 0, function* () {
            let { transportSelectedDate, transportCheckedItems, transportSelectedItem, historySelectedTime, transportFilterCheckedType, transportProcessingCheckedItems } = getState().map;
            // Учитываем тип фильтрации
            const activeList = transportFilterCheckedType === 'filter' ? transportProcessingCheckedItems : transportCheckedItems;
            console.log('[History Stream] Loading with:', {
                transportFilterCheckedType,
                transportCheckedItemsCount: transportCheckedItems === null || transportCheckedItems === void 0 ? void 0 : transportCheckedItems.length,
                transportProcessingCheckedItemsCount: transportProcessingCheckedItems === null || transportProcessingCheckedItems === void 0 ? void 0 : transportProcessingCheckedItems.length,
                activeListCount: activeList === null || activeList === void 0 ? void 0 : activeList.length,
            });
            const [from, to] = transportSelectedDate;
            const timezone = getState().session.timezone;
            let list = activeList || [];
            if (!list.length && transportSelectedItem) {
                list.push(transportSelectedItem.id);
            }
            if (!list.length) {
                console.log('[History Stream] No transports to load');
                return;
            }
            console.log('[History Stream] Loading history for', list.length, 'transports');
            // Очищаем предыдущие данные
            dispatch(actions.clearHistoryTracks());
            // Устанавливаем флаг загрузки в true
            dispatch({
                type: 'MAP_SET_HISTORY_TRACKS_LOADING',
                payload: { loading: true },
            });
            // Разбиваем список на чанки
            const chunks = [];
            for (let i = 0; i < list.length; i += MAX_TRANSPORTS_PER_REQUEST) {
                chunks.push(list.slice(i, i + MAX_TRANSPORTS_PER_REQUEST));
            }
            console.log('[History Stream] Split into', chunks.length, 'chunks of up to', MAX_TRANSPORTS_PER_REQUEST, 'transports');
            // Если воркер уже работает, останавливаем его
            if (historyStreamWorker) {
                historyStreamWorker.postMessage({ type: 'stop' });
                historyStreamWorker.terminate();
                historyStreamWorker = null;
            }
            // Функция для загрузки одного чанка
            const loadChunk = (chunk, chunkIndex) => {
                return new Promise((resolve, reject) => {
                    // Создаём новый воркер для каждого чанка
                    historyStreamWorker = getHistoryStreamWorker();
                    const params = new URLSearchParams({
                        from: from,
                        to: to,
                        timezone: String(timezone),
                        list: chunk.join(','),
                    });
                    const url = `/api/map/transport/conditions/stream?${params.toString()}`;
                    console.log(`[History Stream] Loading chunk ${chunkIndex + 1}/${chunks.length} with ${chunk.length} transports`);
                    let resolved = false;
                    let progressTimer = Date.now();
                    historyStreamWorker.onmessage = function (e) {
                        const { type, data, totalPoints, message, fromCache } = e.data;
                        switch (type) {
                            case 'connected':
                                // Начало загрузки чанка - отправляем начальный прогресс
                                if (!fromCache) {
                                    const baseProgress = chunkIndex * chunk.length;
                                    dispatch(actions.setHistoryTracksProgress(baseProgress, list.length, Math.round((baseProgress / list.length) * 100)));
                                }
                                break;
                            case 'start':
                                break;
                            case 'phaseStarted':
                                break;
                            case 'progress':
                                if (!fromCache) {
                                    const currentTime = Date.now();
                                    if (currentTime - progressTimer > 500) {
                                        progressTimer = currentTime;
                                        // Прогресс от сервера: processed/total где total = интервалы * транспорты
                                        // Но worker разбивает на чанки по TRANSPORT_CHUNK_SIZE (50) транспортов
                                        // Поэтому нужно масштабировать прогресс под текущий чанк
                                        const chunkTotal = chunk.length; // транспортов в текущем чанке
                                        const percent = Math.min(100, Math.round(((e.data.processed / e.data.total) * 100 * chunkTotal) / list.length));
                                        const adjustedProcessed = Math.floor((e.data.processed / e.data.total) * chunkTotal);
                                        const baseProgress = chunkIndex * chunk.length;
                                        const totalProcessed = baseProgress + adjustedProcessed;
                                        dispatch(actions.setHistoryTracksProgress(totalProcessed, list.length, percent));
                                    }
                                }
                                break;
                            case 'batch':
                                if (data && Object.keys(data).length > 0) {
                                    Object.entries(data).forEach(([intervalKey, intervalData]) => {
                                        dispatch({
                                            type: 'MAP_ADD_HISTORY_TRACK_ITEM',
                                            payload: { data: intervalData, intervalKey },
                                        });
                                    });
                                }
                                break;
                            case 'complete':
                                if (!resolved) {
                                    resolved = true;
                                    console.log(`[History Stream] Chunk ${chunkIndex + 1} complete: ${totalPoints} points`);
                                    historyStreamWorker.terminate();
                                    historyStreamWorker = null;
                                    resolve(totalPoints);
                                }
                                break;
                            case 'error':
                                if (!resolved) {
                                    resolved = true;
                                    console.error('[History Stream] Chunk error:', message);
                                    historyStreamWorker.terminate();
                                    historyStreamWorker = null;
                                    reject(new Error(message));
                                }
                                break;
                        }
                    };
                    historyStreamWorker.onerror = function (error) {
                        if (!resolved) {
                            resolved = true;
                            console.error('[History Stream] Worker error:', error);
                            historyStreamWorker.terminate();
                            historyStreamWorker = null;
                            reject(error);
                        }
                    };
                    historyStreamWorker.postMessage({
                        type: 'start',
                        url: url,
                        params: { from, to, timezone, list: chunk.join(',') },
                        forceRefresh: forceRefresh,
                        historySelectedTime: historySelectedTime ? moment(historySelectedTime).format('YYYY-MM-DD HH:mm:ss') : null,
                    });
                });
            };
            // Загружаем чанки последовательно
            try {
                let totalPoints = 0;
                for (let i = 0; i < chunks.length; i++) {
                    const chunkPoints = yield loadChunk(chunks[i], i);
                    totalPoints += chunkPoints || 0;
                }
                console.log('[History Stream] All chunks loaded, total points:', totalPoints);
                dispatch(actions.setHistoryTracksComplete());
            }
            catch (error) {
                console.error('[History Stream] Error loading chunks:', error);
                dispatch(actions.setHistoryTracksComplete());
            }
        });
    };
}
/**
 * Остановка загрузки истории (принудительная)
 */
export function transportHistoryTracksItemsStop() {
    return function () {
        if (historyStreamWorker) {
            historyStreamWorker.postMessage({ type: 'stop' });
            historyStreamWorker.terminate();
            historyStreamWorker = null;
        }
    };
}
/**
 * Загрузка истории с принудительным обновлением (очистка кэша)
 */
export function transportHistoryTracksItemsLoadStreamFresh() {
    return function (dispatch) {
        // Останавливаем текущую загрузку
        dispatch(transportHistoryTracksItemsStop());
        // Запускаем новую с forceRefresh = true
        return dispatch(transportHistoryTracksItemsLoadStream(true));
    };
}
/**
 * Приоритетная загрузка интервала истории
 * Используется когда пользователь перемещает слайдер во время загрузки
 * @param {string} priorityTime - Время в формате 'YYYY-MM-DD HH:mm:ss', вокруг которого нужно загрузить данные (±30 минут)
 */
export function transportHistoryTracksItemsLoadStreamPriority(priorityTime) {
    return function transportHistoryTracksItemsLoadStreamPriorityThunk(dispatch, getState) {
        return __awaiter(this, void 0, void 0, function* () {
            let { transportSelectedDate, transportCheckedItems, transportSelectedItem, transportFilterCheckedType, transportProcessingCheckedItems } = getState().map;
            // Учитываем тип фильтрации
            const activeList = transportFilterCheckedType === 'filter' ? transportProcessingCheckedItems : transportCheckedItems;
            const [from, to] = transportSelectedDate;
            const timezone = getState().session.timezone;
            let list = activeList || [];
            if (!list.length && transportSelectedItem) {
                list.push(transportSelectedItem.id);
            }
            if (!list.length) {
                return;
            }
            // Вычисляем приоритетный интервал (±30 минут от выбранного времени)
            const priorityMoment = moment(priorityTime);
            const priorityFrom = priorityMoment.clone().subtract(30, 'minutes').format('YYYY-MM-DD HH:mm:ss');
            const priorityTo = priorityMoment.clone().add(30, 'minutes').format('YYYY-MM-DD HH:mm:ss');
            console.log('[History Stream] Priority load for time:', priorityTime, 'interval:', priorityFrom, '-', priorityTo);
            // Останавливаем текущую загрузку (но НЕ очищаем данные!)
            if (historyStreamWorker) {
                historyStreamWorker.postMessage({ type: 'stop' });
                historyStreamWorker.terminate();
                historyStreamWorker = null;
            }
            // Устанавливаем флаг загрузки в true (не очищаем данные!)
            dispatch({
                type: 'MAP_SET_HISTORY_TRACKS_LOADING',
                payload: { loading: true },
            });
            // Разбиваем список на чанки
            const chunks = [];
            for (let i = 0; i < list.length; i += MAX_TRANSPORTS_PER_REQUEST) {
                chunks.push(list.slice(i, i + MAX_TRANSPORTS_PER_REQUEST));
            }
            console.log('[History Stream Priority] Split into', chunks.length, 'chunks');
            // Функция для загрузки одного чанка
            const loadChunk = (chunk, chunkIndex) => {
                return new Promise((resolve, reject) => {
                    const worker = getHistoryStreamWorker();
                    // Формируем URL с параметрами, включая приоритетный интервал
                    const params = new URLSearchParams({
                        from: from,
                        to: to,
                        timezone: String(timezone),
                        list: chunk.join(','),
                        priorityFrom: priorityFrom,
                        priorityTo: priorityTo,
                    });
                    const url = `/api/map/transport/conditions/stream?${params.toString()}`;
                    console.log(`[History Stream Priority] Loading chunk ${chunkIndex + 1}/${chunks.length}`);
                    let resolved = false;
                    let progressTimer = Date.now();
                    worker.onmessage = function (e) {
                        const { type, data, totalPoints, message } = e.data;
                        switch (type) {
                            case 'connected':
                                {
                                    // Начало загрузки чанка - отправляем начальный прогресс
                                    const baseProgress = chunkIndex * chunk.length;
                                    dispatch(actions.setHistoryTracksProgress(baseProgress, list.length, Math.round((baseProgress / list.length) * 100)));
                                }
                                break;
                            case 'progress':
                                {
                                    const currentTime = Date.now();
                                    if (currentTime - progressTimer > 500) {
                                        progressTimer = currentTime;
                                        const chunkTotal = chunk.length;
                                        const percent = Math.min(100, Math.round(((e.data.processed / e.data.total) * 100 * chunkTotal) / list.length));
                                        const adjustedProcessed = Math.floor((e.data.processed / e.data.total) * chunkTotal);
                                        const baseProgress = chunkIndex * chunk.length;
                                        const totalProcessed = baseProgress + adjustedProcessed;
                                        dispatch(actions.setHistoryTracksProgress(totalProcessed, list.length, percent));
                                    }
                                }
                                break;
                            case 'batch':
                                if (data && Object.keys(data).length > 0) {
                                    Object.entries(data).forEach(([intervalKey, intervalData]) => {
                                        dispatch({
                                            type: 'MAP_ADD_HISTORY_TRACK_ITEM',
                                            payload: { data: intervalData, intervalKey },
                                        });
                                    });
                                }
                                break;
                            case 'complete':
                                if (!resolved) {
                                    resolved = true;
                                    console.log(`[History Stream Priority] Chunk ${chunkIndex + 1} complete`);
                                    worker.terminate();
                                    resolve(totalPoints);
                                }
                                break;
                            case 'error':
                                if (!resolved) {
                                    resolved = true;
                                    console.error('[History Stream Priority] Chunk error:', message);
                                    worker.terminate();
                                    reject(new Error(message));
                                }
                                break;
                        }
                    };
                    worker.onerror = function (error) {
                        if (!resolved) {
                            resolved = true;
                            console.error('[History Stream Priority] Worker error:', error);
                            worker.terminate();
                            reject(error);
                        }
                    };
                    worker.postMessage({
                        type: 'start',
                        url: url,
                        params: { from, to, timezone, list: chunk.join(','), priorityFrom, priorityTo },
                        forceRefresh: false,
                    });
                });
            };
            // Загружаем чанки последовательно
            try {
                let totalPoints = 0;
                for (let i = 0; i < chunks.length; i++) {
                    const chunkPoints = yield loadChunk(chunks[i], i);
                    totalPoints += chunkPoints || 0;
                }
                console.log('[History Stream Priority] All chunks loaded, total points:', totalPoints);
                dispatch(actions.setHistoryTracksComplete());
            }
            catch (error) {
                console.error('[History Stream Priority] Error loading chunks:', error);
                dispatch(actions.setHistoryTracksComplete());
            }
        });
    };
}
export function transportTaskLoad(id) {
    return function transportTaskLoadThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.get(`/map/transport/${id}/task`);
            return dispatch(actions.setTransportCheckedItemTask(data));
        });
    };
}
export function transportCommandSend(id, name) {
    return function transportCommandSendThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.post(`/map/transport/${id}/command`, { name });
            config.compareEvents['command'].forEach((event) => {
                if (event.key === data.body) {
                    return dispatch(notificationActions.addQueue({
                        text: config.mapTransportCommandMessages[data.code].replace('$name', event.message),
                    }));
                }
            });
        });
    };
}
export function geofenceGroupLoad() {
    return function geofenceGroupLoadThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.get('/map/geofence?type=group');
            return dispatch(actions.setGeofenceGroupItems(data));
        });
    };
}
/**
 * Полное дерево групп+геозон без нарезки по пользователю
 * (привязка геозон к автоколонне не должна зависеть от личного доступа).
 */
export function geofenceGroupAllLoad() {
    return function geofenceGroupAllLoadThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.get('/geofence/group/full');
            return dispatch(actions.setGeofenceGroupItems(data));
        });
    };
}
export function geofenceCreate(params) {
    return function geofenceCreateThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.post('/map/geofence', params);
            return dispatch(actions.addGeofence(data));
        });
    };
}
export function geofenceUpdate(id, params) {
    return function geofenceUpdateThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.put(`/map/geofence/${id}`, params);
            return dispatch(actions.updateGeofence(id, data));
        });
    };
}
export function geofenceOptionsUpdate(id, params) {
    return function geofenceOptionsUpdateThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.put(`/map/geofence/${id}/options`, params);
            return dispatch(actions.updateGeofence(id, data));
        });
    };
}
export function geofenceDelete(id) {
    return function geofenceDeleteThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            yield http.delete(`/map/geofence/${id}`);
            return dispatch(actions.deleteGeofence(id));
        });
    };
}
export function taskLoad() {
    return function taskLoadThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.get('/map/task');
            return dispatch(actions.setTask(data));
        });
    };
}
/** Карточка задания: список без points → догрузка GET /map/task/:id */
export function taskSelectedLoad(item) {
    return function taskSelectedLoadThunk(dispatch, getState) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const taskId = item === null || item === void 0 ? void 0 : item.id;
            dispatch(actions.setTaskSelectedItem(Object.assign(Object.assign({}, item), { ttn_task: Array.isArray(item === null || item === void 0 ? void 0 : item.ttn_task) ? item.ttn_task : [] })));
            if (taskId == null) {
                return;
            }
            try {
                const { data } = yield http.get(`/map/task/${taskId}`);
                const selectedId = (_a = getState().map.taskSelectedItem) === null || _a === void 0 ? void 0 : _a.id;
                if (selectedId !== taskId) {
                    return;
                }
                return dispatch(actions.setTaskSelectedItem(data));
            }
            catch (e) {
                console.error('[taskSelectedLoad]', e);
            }
        });
    };
}
export function hdopLoad(params) {
    return function hdopLoadThunk(dispatch, getState) {
        return __awaiter(this, void 0, void 0, function* () {
            const id = getState().map.transportSelectedItem.id;
            const dt = moment(params.datetime).format('YYYY-MM-DD HH:mm:ss');
            const timezone = getState().session.timezone;
            const { data } = yield http.get(`/map/transport/${id}/hdop?datetime=${dt}&parking_time=${params.parking_time}&timezone=${timezone}`);
            return dispatch(actions.setConditionHdop(Object.assign(Object.assign({}, data), { datetime: params.datetime, transport_id: id, parking_time: params.parking_time })));
        });
    };
}
export function transportTaskInfoLoad(id) {
    return function transportTaskInfoLoadThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.get(`/map/transport/${id}/task`);
            return dispatch(actions.setTransportSelectedItemTask(data));
        });
    };
}
const parseDate = (str) => moment.utc(str);
const isInRange = (commandDate, rangeStart, rangeEnd) => {
    return commandDate.isBetween(rangeStart, rangeEnd, null, '[]');
};
